function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M6.3,96.4c-3.5,0-6.3-2.8-6.3-6.3V13.7c0-3.5,2.8-6.3,6.3-6.3h80.5c0.5,0,1,0.2,1.3,0.6 c0.3,0.4,0.5,0.9,0.4,1.4c-0.1,0.9-0.9,1.6-1.9,1.6H6.3c-1.5,0-2.8,1.2-2.8,2.8v70.2h6.1l-0.2-0.7C9.2,82.5,9,81.8,9,81.1v-9 c0-3.5,2.8-6.3,6.3-6.3h22.3c3.5,0,6.3,2.8,6.3,6.3v9c0,0.7-0.1,1.4-0.4,2.1l-0.2,0.7h30.8c0.5,0,1,0.2,1.3,0.6 c0.3,0.4,0.5,0.9,0.4,1.4c-0.1,0.9-0.9,1.6-1.9,1.6H3.5v2.8c0,1.5,1.2,2.8,2.8,2.8h120.7c1.5,0,2.8-1.2,2.8-2.8v-2.8H84 c-2.3,0-4-2.6-4-6.3c0-3.6,1.7-6.3,4-6.3h36.1c2.3,0,4,2.6,4,6.3c0,0.8-0.1,1.5-0.2,2.2l-0.1,0.6h5.9V54.1c0-1,0.8-1.8,1.8-1.8 c1,0,1.8,0.8,1.8,1.8v36c0,3.5-2.8,6.3-6.3,6.3H6.3z M98.5,83.9H120l0.1-0.3c0.1-0.2,0.5-1.1,0.5-2.5c0-1.4-0.4-2.3-0.5-2.5 l-0.1-0.3H98.5V83.9z M84,78.6c-0.1,0.2-0.5,1.1-0.5,2.5c0,1.4,0.4,2.3,0.5,2.5l0.1,0.3H95v-5.5H84.2L84,78.6z M12.6,81.1 c0,1.5,1.2,2.8,2.8,2.8h22.3c1.5,0,2.8-1.2,2.8-2.8v-2.8H12.6V81.1z M15.3,69.3c-1.5,0-2.8,1.2-2.8,2.8v2.8h27.8v-2.8 c0-1.5-1.2-2.8-2.8-2.8H15.3z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 118.5,
  cy: 22.1,
  r: 20.3,
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 3.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  className: "st2",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 3.5,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 118.5,
  y1: 12,
  x2: 118.5,
  y2: 32.1
}), /*#__PURE__*/React.createElement("line", {
  className: "st2",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 3.5,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 128.5,
  y1: 22.1,
  x2: 108.5,
  y2: 22.1
})));

var SvgCreateClassroom = function SvgCreateClassroom(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 140.6 96.4",
    style: {
      enableBackground: "new 0 0 140.6 96.4"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCreateClassroom, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CreateClassroom.3d61b520.svg";
export { ForwardRef as ReactComponent };